import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Award, Download, QrCode } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Certificates() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/my/certificates").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="certificates-page">
      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold">Achievements</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-2">Your certificates</h1>
      </div>

      {items.length === 0 && (
        <div className="rounded-3xl bg-card border border-border p-10 text-center">
          <Award className="h-14 w-14 mx-auto text-gold" />
          <p className="mt-3 font-semibold">No certificates yet.</p>
          <p className="text-sm text-muted-foreground">Pass a course quiz to earn one.</p>
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-5">
        {items.map((c) => (
          <div key={c.id} data-testid={`cert-${c.id}`}
               className="relative rounded-3xl overflow-hidden border border-gold/40 bg-gradient-to-br from-white to-[#FFF7DA] dark:from-[#0B1B3A] dark:to-[#1c1503] p-8 grain">
            <div className="absolute top-4 right-4 gold-gradient text-[#0B1B3A] text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-widest">Verified</div>
            <div className="flex items-center gap-3 mb-2">
              <img src="/brand/logo.png" alt="" className="h-8 w-8 object-contain" />
              <div>
                <p className="font-display font-bold text-xs">InfiniteSkills Learning Portal</p>
                <p className="text-[10px] text-muted-foreground -mt-0.5">Career Transformation Through Digital Skills</p>
              </div>
            </div>
            <p className="font-display uppercase tracking-[0.3em] text-xs text-gold mt-4">Certificate of Completion</p>
            <p className="mt-6 text-sm text-muted-foreground">This certifies that</p>
            <p className="font-display text-3xl font-bold mt-1">{c.user_name}</p>
            <p className="text-sm text-muted-foreground mt-3">has successfully completed</p>
            <p className="font-display text-xl font-semibold mt-1">{c.course_title}</p>
            <p className="text-xs text-muted-foreground mt-3">Score: <span className="text-gold font-bold">{c.score}%</span> · Issued {new Date(c.issued_at).toLocaleDateString()}</p>

            <div className="mt-6 flex items-center gap-4">
              <div className="h-16 w-16 rounded-xl bg-white flex items-center justify-center border border-border">
                <img alt="qr"
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(window.location.origin + '/verify/' + c.id)}`}
                  className="h-14 w-14" />
              </div>
              <div className="flex-1">
                <p className="text-[10px] text-muted-foreground uppercase tracking-widest">Verify at</p>
                <p className="text-xs font-mono truncate">/verify/{c.id.slice(0, 8)}...</p>
              </div>
              <Button size="sm" variant="outline" className="rounded-full" onClick={() => window.print()}>
                <Download className="h-3.5 w-3.5 mr-1" /> PDF
              </Button>
            </div>
            <p className="mt-6 text-[10px] text-muted-foreground">
              InfiniteSkills Learning Portal · Channel Partner NVDigitalEdu · Founded by Prerna Maheshwari
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
